import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * True when every permission the user holds in the active tenant is
 * `health_care:*` (whatever the name of the função granting it) and they
 * have no admin bypass (admin_wes/admin_cliente/is_superuser). Used to
 * restrict the sidebar (AppShell) and the Painel (DashboardCommonHome) to
 * the Saúde section only — permission-driven, not tied to any role name.
 */
export function useIsHealthOnlyAccess() {
  const { user } = useAuth();

  return useMemo(() => {
    const permissions = user?.permissions || [];
    return (
      permissions.length > 0
      && permissions.every((permission) => permission.startsWith('health_care:'))
      && !user?.is_superuser
    );
  }, [user]);
}

export default useIsHealthOnlyAccess;
